/**
 * A labelled bar for each step (F10 P6): "Your business · Contacts and
 * delivery · Check and send", the current one in bold. Without labels (the
 * builder canvas) it's just the bars. With `onPick`, steps already reached
 * can be clicked to go back to them (`canPick`).
 */
export interface ProgressProps {
  step: number;
  total: number;
  /** One per step, the last being "Check and send". */
  labels?: string[];
  canPick?: (i: number) => boolean;
  onPick?: (i: number) => void;
}

export function Progress({ step, total, labels, canPick, onPick }: ProgressProps) {
  return (
    <ol className="rdr-progress" aria-label={`Step ${step + 1} of ${total}`}>
      {Array.from({ length: total }, (_, i) => {
        const cls = 'rdr-progress-step' + (i < step ? ' done' : i === step ? ' on' : '');
        const inner = (
          <>
            <div className="rdr-progress-seg" />
            {labels?.[i] && <div className="rdr-progress-label">{labels[i]}</div>}
          </>
        );
        const clickable = Boolean(onPick && canPick?.(i));
        return (
          <li key={i} className={cls} aria-current={i === step ? 'step' : undefined} title={labels?.[i]}>
            {clickable ? (
              <button
                type="button"
                className="rdr-progress-btn"
                onClick={() => onPick!(i)}
                aria-label={labels?.[i] ? `Go to ${labels[i]}` : `Go to step ${i + 1}`}
              >
                {inner}
              </button>
            ) : (
              inner
            )}
          </li>
        );
      })}
    </ol>
  );
}
